import { stringToHexColor } from '@/utils/functions/stringToHexColor';
import { Avatar, AvatarProps } from 'antd';

interface Props extends AvatarProps {
  name: string;
  id?: number;
}

export default function EntityAvatar({ id, name, ...props }: Props) {
  const hex = stringToHexColor((id || name).toString());

  return (
    <Avatar {...props} style={{ color: hex.color, background: hex.background }}>
      {name.slice(0, 2)}
    </Avatar>
  );
}
